module.exports = __webpack_public_path__ + "copy-16.6ab7b3f4.svg";